<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :refresh-table="getData"
      item-key="id"
      table-height="70vh"
    >     
      <template slot="action" slot-scope="{ item }">
        <div
          class="d-flex justify-center align-center"
          style="height: 100%; width: 100%; min-height: 56px;"
        >
          <v-btn
            :loading="loadingDownload"
            elevation="2"
            small
            color="warning"
            @click="downloadFee(item.id)"
          >
            download
            <v-icon right dark>mdi-cloud-download</v-icon>
          </v-btn>
        </div>
        </template>
      </TableView>
  </v-card>
</template>

<script>
import { date, showAlert } from '../../lib/helpers';
import { headers, search } from '../../components/report/fee-management/attributes';

export default {
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
  },
  data: () => ({
    isFirstLoad: true,
    options: {},
    headers,
    filter: {
      last_update_date: [],
    },
    search,
    loadingDownload: false,
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.feeManagement.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.feeManagement.flashError;
      },
      set() {
        this.$store.commit('feeManagement/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.feeManagement.errors;
    },

    loading() {
      return this.$store.state.feeManagement.loading;
    },

    allData() {
      return this.$store.state.feeManagement.allData;
    },

    totalData() {
      return this.$store.state.feeManagement.totalData;
    },

    totalPage() {
      return this.$store.state.feeManagement.totalPage;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  methods: {
    getData() {
      this.$store.commit('feeManagement/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('feeManagement/getData', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    async downloadFee(itemId) {
      this.loadingDownload = false;
      await this.$store
        .dispatch('feeManagement/downloadFile', {
          id: itemId,
          date,
        })
        .then((link) => {
          if (link != '') {
            window.location.href = link;
            showAlert(
              this.$store,
              'Download success !',
              'mdi-check-circle',
              'green'
            );
          } else {
            showAlert(
              this.$store,
              'File tidak ditemukan !',
              'mdi-alert',
              'red'
            );
          }
        })
        .finally(() => {
          this.loadingDownload = false;
        });
    },

    closeFlash() {
      this.$store.commit('feeManagement/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.last_update_date = [];
    },

  },
};
</script>

<style>

@media print {
  @page {
    size: landscape;
  }
}
</style>
